module.exports = __webpack_public_path__ + "img/mycoach.b4da6ca1.svg";